import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
import { OFFER_ANCHOR } from '../data/config';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduce = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    let timer: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      timer = setTimeout(hide, 5000);
    };
    const hide = () => {
      setVisible(false);
      timer = setTimeout(() => {
        setIndex(i => (i + 1) % recentBuyers.length);
        show();
      }, 8000);
    };
    timer = setTimeout(show, 4000);
    return () => clearTimeout(timer);
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-3 left-3 z-50 w-[250px] sm:bottom-4 sm:left-4" aria-live="polite" data-id="element-140" data-mp="1gwufeb0wwgi7">
      <AnimatePresence data-id="element-141" data-mp="117frg5fx9zsx">
        {visible && !dismissed && <motion.div key={buyer.name} initial={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 14,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 10
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative" data-id="element-142" data-mp="114tj43l7jg9n">
            <a href={OFFER_ANCHOR} className="flex items-start gap-2.5 rounded-md border-2 border-gold bg-white px-3 py-2.5 shadow-[0_6px_20px_rgba(11,48,91,0.18)]" data-id="element-143" data-mp="i9v08rpoqp55">
              <span className="mt-0.5 flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full border-2 border-check" data-id="element-144" data-mp="s8av95ru2ijx">
                <CheckIcon className="h-2.5 w-2.5 text-check" strokeWidth={4} aria-hidden data-id="element-145" data-mp="23lwfqdmqzvz4" />
              </span>
              <span className="min-w-0 leading-tight" data-id="element-146" data-mp="2apcows6s0ne8">
                <span className="block font-heading text-[11px] font-extrabold uppercase text-navy" data-id="element-147" data-mp="2aqxl0m8qoee7">{buyer.name}</span>
                <span className="block text-[10px] text-ink" data-id="element-148" data-mp="2kn0n5s3lcd15">{buyer.place}</span>
                <span className="mt-1 block text-[10.5px] font-semibold text-brand" data-id="element-149" data-mp="2kkwmdj0znu53">
                  Just purchased the Speech Therapy Bundle™
                </span>
                <span className="block font-heading text-[9.5px] font-extrabold uppercase text-goldDark" data-id="element-150" data-mp="1rzmx8dyb8hqj">
                  {buyer.minutes} minutes ago
                </span>
              </span>
            </a>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full border-2 border-navy bg-white text-navy" data-id="element-151" data-mp="21uyfh68xg731">
              <XIcon className="h-3 w-3" strokeWidth={3} data-id="element-152" data-mp="1e4u7kmophl68" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}